const getRandomItemsInArray = (array, numItems) => {
  const tempArray = [...array]

  // Shuffle the array
  for (let i = tempArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [tempArray[i], tempArray[j]] = [tempArray[j], tempArray[i]]
  }

  // Return the first numItems elements of the shuffled array
  return tempArray.slice(0, numItems)
}

const setAISlideCountForTracking = (socketData, editor) => {
  const { aiGeneratedSlideCount, importedFileAIGeneratedSlideCount } = socketData

  if (!aiGeneratedSlideCount && !importedFileAIGeneratedSlideCount) return
  editor.updateCurrentUserAction({
    hasUsedAIGeneratedSlides: true,
  })
  editor.patchPresentationAction({
    presentationContainsAIGeneratedSlides: true,
  })
  if (aiGeneratedSlideCount) {
    editor.patchPresentationAction({ aiGeneratedSlideCount })
  }
  if (importedFileAIGeneratedSlideCount) {
    editor.patchPresentationAction({ importedFileAIGeneratedSlideCount })
  }
}
const shouldGenerateSlideOptions = (question) => {
  if (!question || (question && question.trim().length === 0)) {
    return false
  }

  return true
}
export default {
  getRandomItemsInArray,
  setAISlideCountForTracking,
  shouldGenerateSlideOptions,
}
